import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import ProgressBar from "./ProgressBar";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { TextField } from "@material-ui/core/";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

import "../styles/main.css";

const theme = createMuiTheme({
  direction: "rtl",
});

const StyledTitle = withStyles({
  root: {
    fontSize: "20px",
    letterSpacing: 0,
    color: "#4A4547",
    opacity: 1,
    lineHeight: "1.7rem",
    align: "left",
    marginBottom: "16px",
  },
})(Typography);

const StyledText = withStyles({
  root: {
    width: "83%",
    textAlign: "right",
    margin: "24px 0 10px 0",
    fontSize: "14px",
    letterSpacing: 0,
    color: "#4A4547",
    opacity: 1,
    lineHeight: "1.5rem",
  },
})(Typography);

const StyledButtonNext = withStyles({
  root: {
    height: "48px",
    background: "#32C6A9 0% 0% no-repeat padding-box",
    borderRadius: "4px",
    opacity: 1,
    shadow: "none",
    fontSize: "18px",
    fontWeight: "bold",
    "&:hover": {
      backgroundColor: "#32C6A9",
    },
    "&:active": {
      backgroundColor: "#4A4547",
    },
  },
})(Button);

const StyledFormControl = withStyles({
  root: {
    display: "flex",
    marginBottom: "20px",

    "& label": {
      color: "#4A4547",
      fontSize: "14px",
    },

    "& label.Mui-focused": {
      color: "#32C6A9",
      fontSize: "14px",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "1px solid #707070",
        padding: "0px",
      },
      "&.Mui-focused fieldset": {
        border: "2px solid #32C6A9",
        paddingTop: "20px",
        color: "black",
      },
      padding: "0px",
      height: "48px",
    },
  },
})(FormControl);

const StyledTextField = withStyles({
  root: {
    width: "100%",
    height: "48px",
    padding: "0px",

    dir: "rtl",
    opacity: 1,
    color: "#4A4547",
    borderRadius: "4px",
    marginBottom: "24px",
    "& label": {
      color: "#4A4547",
      fontSize: "14px",
    },

    "& label.Mui-focused": {
      color: "#32C6A9",
      fontSize: "14px",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "1px solid #707070",
        opacity: 1,
        padding: "0px",
      },
      "&.Mui-focused fieldset": {
        border: "2px solid #32C6A9",
      },
      padding: "0px",
      height: "48px",
    },
  },
})(TextField);

const StyledFormControlLabel = withStyles({
  root: {
    color: "#4A4547",
  },
})(FormControlLabel);

export class FirstPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  continue = (e) => {
    e.preventDefault();
    this.props.nextStep();
    this.props.finalizeClassSubclass();
  };

  back = (e) => {
    e.preventDefault();
    this.props.prevStep();
  };

  render() {
    const {
      values,
      cancel,
      tempClassesArray,
      handleChangeGradeLevel,
      handleChangeClassValues,
      handleChangeLanguage,
      handleChangeClassRadio,
      handleChangeSubClassValues,
      handleChangeName,
      handleChangePhoneNumber,
    } = this.props;

    return (
      <React.Fragment>
        <Grid container spacing={0}>
          <Grid item xs={4}>
            <img
              className="pageImg"
              src={require("../assets/carousel-img/Page2.png")}
              alt="pic"
            />
          </Grid>
          <Grid item xs={8}>
            <div style={{ direction: "rtl" }}>
              <ProgressBar currStep={this.props.currStep} />
            </div>
            <form onSubmit={this.continue} className="page-form">
              <div className="main-content">
                <div
                  className="wrapper"
                  dir="rtl"
                  style={{ overflow: "hidden" }}
                >
                  <StyledTitle
                    variant="h6"
                    display="block"
                    className="title"
                    gutterBottom
                  >
                    בחירת כיתה
                  </StyledTitle>

                  <ThemeProvider theme={theme}>
                    <StyledTextField
                      autoFocus
                      required={true}
                      label="שם מלא*"
                      variant="outlined"
                      value={values.fullName}
                      onChange={(e) => handleChangeName(e)}
                    ></StyledTextField>
                  </ThemeProvider>

                  <ThemeProvider theme={theme}>
                    <StyledTextField
                      inputMode="numeric"
                      pattern="[0-9]*"
                      error={this.props.invalidPhone ? true : false}
                      required={true}
                      label="הכנס את מספר הטלפון של התלמיד*"
                      variant="outlined"
                      value={values.phoneNumber}
                      onChange={(e) => handleChangePhoneNumber(e)}
                    ></StyledTextField>

                    <p className="error-text">
                      {this.props.invalidPhone ? "Incorrect entry!" : " "}
                    </p>
                  </ThemeProvider>

                  <ThemeProvider theme={theme}>
                    <StyledFormControl variant="outlined" required>
                      <Select
                        native
                        value={values.gradeLevel}
                        onChange={(e) => handleChangeGradeLevel(e)}
                        style={{ fontSize: "14px", color: "#4A4547" }}
                      >
                        <option
                          disabled
                          value={""}
                          style={{
                            borderBottom: "1px solid #E5E5E5",
                            display: "none",
                          }}
                        >
                          כיתה*
                        </option>
                        {this.props.classGradeValues.map((val) => (
                          <option
                            value={val}
                            style={{ borderBottom: "1px solid #E5E5E5" }}
                          >
                            {val}
                          </option>
                        ))}
                        {/* <option
                          value={"יא"}
                          style={{ borderBottom: "1px solid #E5E5E5" }}
                        >
                          יא
                        </option>
                        <option
                          value={"יב"}
                          style={{ borderBottom: "1px solid #E5E5E5" }}
                        >
                          יב
                        </option> */}
                      </Select>
                    </StyledFormControl>
                  </ThemeProvider>

                  {this.props.tempClassesArray.map((co, index) => (
                    <div className="classSubclassRow">
                      <div
                        className="classesAndSubClassesFields"
                        style={{ width: "100%", display: "flex" }}
                      >
                        <ThemeProvider theme={theme}>
                          <StyledFormControl
                            required
                            variant="outlined"
                            style={{
                              width: co.classSubValues.length ? "48%" : "100%",
                            }}
                          >
                            <Select
                              native
                              value={co.classSelection}
                              onChange={(e) =>
                                handleChangeClassValues(e, index)
                              }
                              style={{
                                fontSize: "14px",
                                color: "#4A4547",
                                width: "100%",
                              }}
                            >
                              <option
                                disabled
                                value={""}
                                style={{
                                  borderBottom: "1px solid #E5E5E5",
                                  display: "none",
                                }}
                              >
                                מקצוע*{" "}
                              </option>
                              {co.classValues.map((val) => (
                                <option
                                  className="select-option"
                                  key={val}
                                  value={val}
                                  style={{
                                    borderBottom: "1px solid #E5E5E5",
                                    backgroundClip: "red",
                                  }}
                                >
                                  {val}
                                </option>
                              ))}
                            </Select>
                          </StyledFormControl>
                        </ThemeProvider>

                        {co.classSubValues.length > 0 ? (
                          <ThemeProvider theme={theme}>
                            <StyledFormControl
                              required
                              variant="outlined"
                              style={{ width: "48%", marginRight: "4%" }}
                            >
                              <Select
                                native
                                value={co.classSubSelection}
                                onChange={(e) =>
                                  handleChangeSubClassValues(e, index)
                                }
                                style={{ fontSize: "14px", color: "#4A4547" }}
                              >
                                <option
                                  disabled
                                  value={""}
                                  style={{
                                    borderBottom: "1px solid #E5E5E5",
                                    display: "none",
                                  }}
                                >
                                  בחר רמת כיתה*{" "}
                                </option>
                                {co.classSubValues.map((val) => (
                                  <option
                                    className="select-option"
                                    key={val}
                                    value={val}
                                    style={{
                                      borderBottom: "1px solid #E5E5E5",
                                      backgroundClip: "red",
                                    }}
                                  >
                                    {val}
                                  </option>
                                ))}
                              </Select>
                            </StyledFormControl>
                          </ThemeProvider>
                        ) : null}
                      </div>
                      {tempClassesArray.length > 1 && index > 0 ? (
                        <span className="">
                          <i
                            className="material-icons remove-icon"
                            style={{
                              position: "absolute",
                              paddingTop: "13px",
                              paddingRight: "6px",
                            }}
                            onClick={() => this.props.removeClassObject(index)}
                          >
                            highlight_off
                          </i>
                        </span>
                      ) : null}
                    </div>
                  ))}

                  {/* Button for adding classes */}
                  {tempClassesArray.length < 10 ? (
                    <p className="explanation-classes">
                      הוסף כיתה חדשה{" "}
                      <span
                        style={{
                          color: this.props.enableAddNewClass
                            ? "#32C6A9"
                            : "#4A454729",
                          cursor: "pointer",
                        }}
                      >
                        <i
                          className="material-icons"
                          style={{
                            position: "relative",
                            fontSize: "22px",
                            marginRight: "2px",
                            top: "7px",
                          }}
                          onClick={this.props.addNewClassObject}
                        >
                          add_circle
                        </i>
                      </span>
                    </p>
                  ) : (
                    <p className="error-text" style={{ paddingTop: "4px" }}>
                      You can't add more than 10 classes!
                    </p>
                  )}

                  <StyledText
                    variant="overline"
                    display="block"
                    className="text"
                    gutterBottom
                    dir="rtl"
                  >
                    במידה ויתאפשר האם תרצה להיות בכיתה:
                  </StyledText>

                  <ThemeProvider>
                    <FormControl>
                      <RadioGroup
                        value={values.classRadio}
                        aria-label="classRadio"
                        name="customized-radios"
                        onChange={(e) => handleChangeClassRadio(e)}
                      >
                        <StyledFormControlLabel
                          value="מעורבת (בנים ובנות)"
                          control={<Radio color="default" />}
                          label="מעורבת (בנים ובנות)"
                          labelPlacement="end"
                        />
                        <StyledFormControlLabel
                          value="בנים לחוד"
                          control={<Radio color="default" />}
                          label="בנים לחוד"
                          labelPlacement="end"
                        />
                        <StyledFormControlLabel
                          value="בנות לחוד"
                          control={<Radio color="default" />}
                          label="בנות לחוד"
                          labelPlacement="end"
                        />
                      </RadioGroup>
                    </FormControl>
                  </ThemeProvider>

                  <StyledText
                    variant="overline"
                    display="block"
                    className="text"
                    gutterBottom
                    dir="rtl"
                  >
                    במידת האפשר האם תרצה לבחור בין שיעורים בעברית או ערבית
                  </StyledText>

                  <ThemeProvider>
                    <FormControl>
                      <RadioGroup
                        value={values.language}
                        aria-label="language"
                        name="customized-radios"
                        onChange={(e) => handleChangeLanguage(e)}
                      >
                        <StyledFormControlLabel
                          value="עברית"
                          control={<Radio color="default" />}
                          label="עברית"
                          labelPlacement="end"
                          style={{ fontSize: "14px", color: "#4A4547" }}
                        />
                        <StyledFormControlLabel
                          value="ערבית"
                          control={<Radio color="default" />}
                          label="ערבית"
                          labelPlacement="end"
                        />
                      </RadioGroup>
                    </FormControl>
                  </ThemeProvider>
                </div>
              </div>
              <div className="button-container" dir="rtl">
                <div
                  className="button-back"
                  variant="contained"
                  onClick={this.back}
                >
                  <i
                    className="material-icons"
                    style={{
                      fontSize: "32px",
                      marginLeft: "5px",
                      marginRight: "-12px",
                    }}
                  >
                    keyboard_arrow_right
                  </i>
                  חזור
                </div>

                <div
                  className="button-cancel"
                  variant="contained"
                  onClick={cancel}
                >
                  לבטל
                </div>
                <StyledButtonNext
                  color="secondary"
                  variant="contained"
                  type="submit"
                >
                  המשך
                  <i
                    className="material-icons"
                    style={{
                      fontSize: "32px",
                      marginRight: "5px",
                      marginLeft: "-12px",
                    }}
                  >
                    keyboard_arrow_left
                  </i>
                </StyledButtonNext>
              </div>

              <p
                className="contact-text-bottom"
                variant="caption"
                display="block"
              >
                לכל שאלה, בעיה אנחנו כאן
                <br />
                טלפון: <a href={"tel:052-8808558"}>052-8808558</a> מייל:{" "}
                <a href={"mailto:contact@class.me"}>contact@class.me</a>
                <a className="terms" href={"https://class.me/termsHE.html"}>
                  תנאי שימוש ומדיניות פרטיות
                </a>
              </p>
            </form>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

export default FirstPage;
